<template>
  <div>
    <template v-if="isPreloadContent">
      <!-- 加载中的loader -->
      <div :class="{ 'hide-content': isReady }">
        <slot name="loader">
          <!-- 默认loader -->
          <ContentLoader viewBox="0 0 375 200" :speed="2" primaryColor="#f3f3f3" secondaryColor="#e6e6e6">
            <circle cx="150" cy="86" r="8" />
            <circle cx="194" cy="86" r="8" />
            <circle cx="238" cy="86" r="8" />
          </ContentLoader>
        </slot>
      </div>
      <div :class="{ 'hide-content': !isReady }">
        <!-- 加载完成的组件内容 -->
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <!-- 加载中的loader -->
      <slot name="loader" v-if="!isReady">
        <!-- 默认loader -->
        <ContentLoader viewBox="0 0 375 200" :speed="2" primaryColor="#f3f3f3" secondaryColor="#e6e6e6">
          <circle cx="150" cy="86" r="8" />
          <circle cx="194" cy="86" r="8" />
          <circle cx="238" cy="86" r="8" />
        </ContentLoader>
      </slot>
      <!-- 加载完成的组件内容 -->
      <slot v-else></slot>
    </template>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ContentLoader from './content-loader.vue';

@Component({
  components: {
    ContentLoader,
  },
})
export default class BaseComponent extends Vue {
  /** 组件是否初始化完成 */
  @Prop({ default: false }) isReady!: boolean;
  /** 是否预先加载内容 */
  @Prop({ default: false }) isPreloadContent!: boolean;
}
</script>
<style lang="less" scoped>
.hide-content {
  height: 0;
  width: 0;
  overflow: hidden;
}
</style>
